import PropTypes from "prop-types"
import React from "react"
import { Form } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { PhoneInput, validatePhoneNumber } from "ui/Input/PhoneInput"
import { CustomInputError } from "ui/CustomInputError"

export const PhonePasswordRecovery = ({ errors, form }) => {
  PhonePasswordRecovery.propTypes = {
    errors: PropTypes.any,
    form: PropTypes.object.isRequired
  }
  const { t } = useTranslation()
  return (
    <>
      <Text type="sub" color="primary" className="justify-center mb-m">
        {t("password_recovery.phone_recovery_info")}
      </Text>
      <Form.Item
        label={t("password_recovery.phone")}
        name="phone_number"
        required={false}
        rules={[
          {
            validator: (_, value) => {
              if (!value?.fullNumber) {
                return Promise.reject(t("form_validation.phone_required"))
              }
              return validatePhoneNumber(value.fullNumber)
            }
          }
        ]}
        help={errors ? <CustomInputError errorKey={errors} /> : null}
      >
        <PhoneInput
          placeholder={t("password_recovery.email_placeholder")}
          onChange={(value) => {
            form.setFieldsValue({ phone_number: value })
          }}
        />
      </Form.Item>
    </>
  )
}
